import axios from "axios";
import Cookies from "js-cookie";

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) prom.reject(error);
    else prom.resolve(token);
  });
  failedQueue = [];
};

const isLocal = window.location.hostname === "localhost";
// axios instance
const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_ENDPOINT}`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// request interceptor
// api.interceptors.request.use(
//   (config) => {
//     // old code
//     // const token = Cookies.get("guradPlus_token");
//     // if (token) {
//     //   config.headers["Authorization"] = `Token ${token}`;
//     // }

//     // new code
//     const sessionCookie = Cookies.get("guradPlus_session")
//     const sessionData = JSON.parse(sessionCookie);
//     if (sessionData !== null) {
//       const token = sessionData.jwt;
//       console.log('token: ', token)
//       if (token) {
//         config.headers["Authorization"] = `Token ${token}`;
//       }
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// using cookies
// api.interceptors.request.use(
//   (config) => {
//     const sessionCookie = Cookies.get("guradPlus_session");

//     if (sessionCookie) {
//       try {
//         const sessionData = JSON.parse(sessionCookie);
//         if (sessionData && sessionData.jwt) {
//           config.headers["Authorization"] = `Token ${sessionData.jwt}`;
//         }
//       } catch (err) {
//         console.error("Invalid session cookie JSON:", sessionCookie);
//         Cookies.remove("guradPlus_session");
//       }
//     }

//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// using session storage
api.interceptors.request.use((config) => {
  const storedSession = sessionStorage.getItem("guradPlus_session");

  if (storedSession) {
    const parsedSession = JSON.parse(storedSession);
    const sessionData = parsedSession?.sessionData; 
    const token = sessionData?.jwt;
    if (token) {
      config.headers["Authorization"] = `Token ${token}`;
    }
  }

  return config;
});


// response interceptor
api.interceptors.response.use(
  (res) => {
    if (res.config.url.includes("/authenticate")) {
      const { jwt, role, accessId } = res.data.data;
      if (jwt || role || accessId) {
        const sessionData = {
          jwt,
          role,
          accessId,
        };
        // store in session storage
            sessionStorage.setItem("guradPlus_session", JSON.stringify({ sessionData }));
        // Cookies.set("guradPlus_session", JSON.stringify(sessionData), {
        //   expires: 1,
        //   secure: true,
        //   // sameSite: isLocal ? "lax" : "strict",
        //   sameSite: "none",
        // });
      }
    }

    return res;
  },
  (error) => Promise.reject(error)
);

export default api;
